<template>
	<div class="featured_posts_listing">
		<div class="container">
			<header class="header-desktop" :style="headerStyle">
				<h2 v-if="title" v-html="title"></h2>

				<div class="right">
					<primary-button
						v-if="ctaLink"
						:link="ctaLink"
						:label="ctaLabel"
						theme="dark"
					></primary-button>

					<div v-if="showNavigation" class="slider_navigation">
						<div
							:class="
								'swiper-button-prev swiper-button-prev-' + computedSectionId
							"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M15 18L9 12L15 6"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</div>
						<div
							:class="
								'swiper-button-next swiper-button-next-' + computedSectionId
							"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M9 18L15 12L9 6"
									stroke="currentColor"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</div>
					</div>
				</div>
			</header>

			<template v-if="no_slider === 'true'">
				<post-tile
					v-for="(tile, index) in parsedPageLinks"
					:key="index"
					:name="tile.title"
					:short_description="tile.description"
					:image="tile.image ? tile.image.url : null"
					:permalink="{
						url: tile.url,
						target: '_self',
						title: tile.title,
					}"
					:tag="tile.category"
					:post_type="tile.post_type"
					class="featured_post"
				></post-tile>
			</template>
			<template v-else>
				<div class="slider-slider">
					<div class="swiper" :class="computedSectionId">
						<div class="swiper-wrapper">
							<template v-if="type === 'post'">
								<post-tile
									class="swiper-slide featured_post"
									v-for="(tile, index) in parsedPageLinks"
									:key="index + '_standard'"
									:name="tile.title"
									:short_description="tile.description"
									:image="tile.image ? tile.image.url : null"
									:permalink="{
										url: tile.url,
										target: '_self',
										title: tile.title,
									}"
									:tag="tile.category"
									:post_type="tile.type"
								></post-tile>
							</template>
						</div>
						<!-- <div
							class="swiper-pagination"
							:class="'swiper-pag-' + computedSectionId"
							v-if="Object.keys(parsedPageLinks).length > 4"
						></div> -->
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import PostTile from './PostTile.vue';
// import SecondaryButton from './SecondaryButton.vue';
// import CarouselArrow from './CarouselArrow.vue';
import Swiper from 'swiper';
import PrimaryButton from './PrimaryButton.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			swiper: null,
		};
	},

	props: {
		title: {
			default: 'Basic Page Links (with description)',
		},
		cta: {},
		basic_page_links_description: {},
		type: {},
		section_id: {},
		no_slider: {
			default: 'false',
		},
	},

	computed: {
		parsedPageLinks() {
			if (!this.basic_page_links_description) {
				return [];
			}

			if (Array.isArray(this.basic_page_links_description)) {
				return this.basic_page_links_description;
			}

			if (
				this.basic_page_links_description &&
				typeof this.basic_page_links_description === 'object'
			) {
				return Object.values(this.basic_page_links_description);
			}

			let parsed = [];

			try {
				const data = JSON.parse(this.basic_page_links_description);
				if (Array.isArray(data)) {
					parsed = data;
				} else if (data && typeof data === 'object') {
					parsed = Object.values(data);
				}
			} catch (e) {
				parsed = [];
			}

			return parsed;
		},

		parsedCta() {
			if (!this.cta) {
				return null;
			}

			if (typeof this.cta === 'object') {
				return this.cta;
			}

			try {
				return JSON.parse(this.cta);
			} catch (e) {
				return null;
			}
		},

		ctaLink() {
			if (!this.parsedCta) {
				return null;
			}

			if (this.parsedCta.link) {
				return this.parsedCta.link;
			}

			return this.parsedCta;
		},

		ctaLabel() {
			if (!this.parsedCta) {
				return '';
			}

			if (this.parsedCta.title) {
				return this.parsedCta.title;
			}

			if (
				this.parsedCta.link &&
				this.parsedCta.link.title
			) {
				return this.parsedCta.link.title;
			}

			return '';
		},

		computedSectionId() {
			const sanitize = (value) => {
				if (!value || typeof value !== 'string') {
					return '';
				}

				let cleaned = value
					.trim()
					.replace(/^#/, '')
					.replace(/[^a-zA-Z0-9-_]/g, '-')
					.replace(/-{2,}/g, '-')
					.replace(/^-+|-+$/g, '')
					.toLowerCase();

				if (!cleaned) {
					return '';
				}

				if (!/^[a-z]/.test(cleaned)) {
					cleaned = 'section-' + cleaned;
				}

				return cleaned;
			};

			const provided = sanitize(this.section_id);

			if (provided) {
				return provided;
			}

			return 'featured-posts-' + this._uid;
		},

		showNavigation() {
			// Hide navigation controls entirely when there is a single tile
			return this.parsedPageLinks.length > 1;
		},
		headerStyle() {
			const windowWidth =
				this.window.width > 0
					? this.window.width
					: typeof window !== 'undefined'
						? window.innerWidth
						: 0;

			if (!this.showNavigation && windowWidth > 1024) {
				return { height: '75px' };
			}

			return {};
		},
	},

	watch: {},

	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			this.initSliders();
		},

		initSliders() {
			const swiperOptions = {
				slidesPerView: 4,
				spaceBetween: 24,
				loop: false,
				grabCursor: false,
				// watchSlidesVisibility: true,
				// watchSlidesProgress: true,
				// observer: true,
				// observeParents: true,
				breakpoints: {
					400: {
						slidesPerView: 1,
						spaceBetween: 24,
						centeredSlides: false,
					},
					1024: {
						slidesPerView: 1,
						spaceBetween: 24,
					},
					1240: {
						slidesPerView: 4,
						spaceBetween: 24,
					},
					1490: {
						slidesPerView: 4,
						spaceBetween: 24,
					},
					1920: {
						slidesPerView: 4,
						spaceBetween: 24,
					},
				},
				hashNavigation: {
					watchState: true,
				},
				pagination: {
					el: '.swiper-pag-' + this.computedSectionId,
					clickable: true,
				},
				on: {
					init: function () {
						for (let i = 0; i < this.slides.length; i++) {
							// Set opacity to 1 for the activeIndex and the next two slides
							if (i >= this.activeIndex && i <= this.activeIndex + 3) {
								this.slides[i].style.opacity = 1;
								this.slides[i].style.pointerEvents = 'all';
							} else {
								// Set opacity to 0.3 for all other slides
								this.slides[i].style.opacity = 0;
								this.slides[i].style.pointerEvents = 'none';
							}
						}
					},
					activeIndexChange: function () {
						for (let i = 0; i < this.slides.length; i++) {
							// Set opacity to 1 for the activeIndex and the next two slides
							if (i >= this.activeIndex && i <= this.activeIndex + 3) {
								this.slides[i].style.opacity = 1;
								this.slides[i].style.pointerEvents = 'all';
							} else {
								// Set opacity to 0.3 for all other slides
								this.slides[i].style.opacity = 0;
								this.slides[i].style.pointerEvents = 'none';
							}
						}
					},
					resize: function () {
						for (let i = 0; i < this.slides.length; i++) {
							// Set opacity to 1 for the activeIndex and the next two slides
							if (i >= this.activeIndex && i <= this.activeIndex + 3) {
								this.slides[i].style.opacity = 1;
								this.slides[i].style.pointerEvents = 'all';
							} else {
								// Set opacity to 0.3 for all other slides
								this.slides[i].style.opacity = 0;
								this.slides[i].style.pointerEvents = 'none';
							}
						}
					},
					reachEnd: function () {
						if (!this.slides || this.slides.length === 0) {
							return;
						}
						this.slides[this.slides.length - 1].style.opacity = 1;
						this.slides[this.slides.length - 1].style.pointerEvents = 'all';
					},
					fromEdge: function () {
						if (!this.slides || this.slides.length === 0) {
							return;
						}
						this.slides[this.slides.length - 1].style.opacity = 0;
						this.slides[this.slides.length - 1].style.pointerEvents = 'none';
					},
					reachBeginning: function () {
						for (let i = 0; i < this.slides.length; i++) {
							// Set opacity to 1 for the activeIndex and the next two slides
							if (i >= this.activeIndex && i <= this.activeIndex + 3) {
								this.slides[i].style.opacity = 1;
								this.slides[i].style.pointerEvents = 'all';
							} else {
								// Set opacity to 0.3 for all other slides
								this.slides[i].style.opacity = 0;
								this.slides[i].style.pointerEvents = 'none';
							}
						}
					},
				},
			};
			if (this.showNavigation) {
				swiperOptions.navigation = {
					nextEl: '.swiper-button-next-' + this.computedSectionId,
					prevEl: '.swiper-button-prev-' + this.computedSectionId,
				};
			}
			// eslint-disable-next-line no-unused-vars
			var swiper = new Swiper('.' + this.computedSectionId, swiperOptions);
		},

		// hasBeenClickedHandler(value) {
		// 	this.hasBeenClicked = value;
		// },
	},

	components: {
		PostTile,
		// SecondaryButton,
		// CarouselArrow,
		PrimaryButton,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.featured_posts_listing {
	grid-column: span 12;
	overflow-x: hidden;
	background: var(--white);
	padding-top: var(--padding-top);
	padding-bottom: var(--padding-bottom);

	@media (max-width: $mobile-xl) {
		padding-top: var(--padding-top-mobile);
		padding-bottom: var(--padding-bottom-mobile);
	}

	.container {
		position: relative;
	}

	@media (max-width: $tablet) {
		padding: 48px 0 48px;
	}

	.slider-slider {
		grid-column: span 12;
		/* overflow: hidden; */
		padding-top: 55px;
		padding-bottom: 55px;
		margin-top: -55px;
		position: relative;
		z-index: 5;

		@media (max-width: $tablet) {
			grid-column: span 12;
			overflow: visible;
		}

		@media (max-width: $mobile-xl) {
			grid-column: span 12;
			padding-top: 0;
			margin-top: unset;
		}

		@media (max-width: $mobile) {
			grid-column: span 4;
		}

		.swiper-slider {
			pointer-events: none;
		}

		.swiper-slide {
			height: unset;
			opacity: 1;
			transition: 0.2s ease all;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			/* @media (max-width: $mobile-xl) {
				&.swiper-slide-next {
					opacity: 0.5 !important;
					transition: 0.2s ease all;
				}
			} */
		}
	}

	.swiper-wrapper {
		z-index: 15;
	}

	header {
		grid-column: span 12;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
		/* pointer-events: none; */
		// border-top: 1px solid var(--white);
		// padding-top: var(--gutter-tablet-desktop);

		@media (max-width: $tablet) {
			grid-column: span 12;
			justify-content: space-between;
		}

		@media (max-width: $mobile) {
			grid-column: span 4;
			flex-direction: column;
			align-items: center;
			gap: 10px;
		}

		a.site_button_secondary {
			pointer-events: all;
		}

		h2,
		h3 {
			font-family: var(--primary-font-family-heading);
			/* font: normal normal 600 34px/40px var(--primary-font-family-display); */
			color: var(--cobalt);
			margin: 0;

			@media (max-width: $tablet) {
				color: var(--cobalt);
			}
		}

		h5 {
			margin: 0;
		}

		&.header-mobile {
			display: none;
			z-index: 10;

			@media (max-width: $mobile-xl) {
				border-top: 0 solid var(--cobalt);
				padding-top: 0;
				display: flex;
				justify-content: flex-end;
				align-items: center;
			}

			/* a {
				&.site_button_secondary {
					padding-left: 0;
					display: none;
					width: auto;

					@media (max-width: $mobile-xl) {
						display: flex;
						color: var(--white);
					}
				}
			} */
		}

		&.header-desktop {
			position: relative;
			z-index: 10;
			height: 150px;
			border-top: 1px solid var(--fpe-light-grey);
			padding-top: 48px;

			@media (max-width: $mobile-xl) {
				height: unset;
			}

			h2 {
				color: var(--fpe-blue);
			}

			.right {
				position: relative;
				display: flex;
				flex-direction: column;
				gap: 24px;

				@media (max-width: $mobile-xl) {
					flex-direction: row;
					justify-content: space-between;
					gap: 24px;
					width: 100%;
				}
			}
		}

		/* .site_button_secondary {
			&::v-deep {
				span {
					color: var(--cobalt);
				}

				svg {
					path,
					line {
						stroke: transparent;
						fill: var(--light-blue);
					}
				}
			}
		} */
	}

	.container {
		column-gap: var(--gutter-tablet-desktop);
		row-gap: calc(var(--gutter-tablet-desktop) * 1);

		@media (max-width: $tablet) {
			grid-template-columns: repeat(12, 1fr);
			column-gap: var(--gutter-mobile);
			row-gap: var(--gutter-mobile);
		}

		@media (max-width: $mobile) {
			grid-template-columns: repeat(4, 1fr);
			column-gap: var(--gutter-mobile);
		}

		.post_tile {
			height: auto;
			transition: 0.2s ease opacity;
			grid-column: span 3;
			/* opacity: 1 !important; */

			@media (max-width: 1920px) {
				grid-column: span 3;
			}

			@media (max-width: 1490px) {
				grid-column: span 3;
			}

			@media (max-width: $tablet) {
				grid-column: span 3;
			}

			@media (max-width: $mobile-xl) {
				grid-column: span 6;
			}

			@media (max-width: $mobile) {
				grid-column: span 4;
			}

			&::v-deep {
				.content {
					background: var(--white);
				}

				@media (max-width: $mobile-xl) {
					display: flex;
					flex-direction: column;

					.content {
						height: auto;
						background: var(--white);
					}
				}
			}
		}
	}
}

.swiper {
	width: 100%;
}

.swiper-next-prev {
	position: absolute;
	width: 100%;
	top: calc(50% + 30px);
	transform: translateY(-50%);
	z-index: 40;
	z-index: 20;

	@media (max-width: $mobile-xl) {
		/* max-width: calc(100% - 40px); */
		/* top: -42px; */
		/* transform: translateX(-50%); */
		top: calc(50% + 40px);
		bottom: unset;
		/* margin: 0 20px; */
	}

	.prev {
		opacity: 1;
		margin-left: 0;

		@media (max-width: $tablet) {
			top: 50%;
			margin-left: -9px;
		}
	}

	.next {
		opacity: 1;
		margin-right: 0;

		@media (max-width: $tablet) {
			top: 50%;
			margin-right: -9px;
		}
	}
}

.slider_navigation {
	position: relative;
	top: 0;
	right: 0;
	z-index: 10;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	width: 180px;
	height: 48px;
	justify-content: space-between;

	.swiper-button-prev,
	.swiper-button-next {
		width: 40px;
		height: 46px;
		background: var(--white);
		border-radius: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: 0.2s ease all;
		color: var(--fpe-blue);
		border: 1px solid var(--fpe-light-grey);
		position: relative;
		top: 0;
		margin-top: 0;
		left: 0;
		right: 0;
		min-width: 80px;
		/* box-shadow: 0px -0px 0 var(--fpe-blue); */

		&:hover {
			background: var(--white);
			transition: 0.2s ease all;
			color: var(--fpe-blue);
			/* box-shadow: 1px -1px 0 var(--fpe-blue); */

			svg {
				path {
					stroke: var(--fpe-blue);
				}
			}
		}

		svg {
			width: 16px;
			height: 16px;
		}
	}
}

.swiper-pagination {
	position: relative !important;
	grid-column: span 12;
	display: inline-flex;
	justify-content: center;
	gap: 10px;
	left: 0;
	width: 100%;
	position: absolute !important;
	top: 12px !important;
	bottom: unset !important;
	flex-wrap: wrap;
	z-index: 10;

	@media (max-width: $mobile-xl) {
		gap: 8px;
		display: none;
		/* top: -55px !important; */
	}

	& > .swiper-pagination-bullet-active {
		background: var(--cobalt) !important;
	}
}

/* .swiper-slide-prev {
	transition: 0.2s ease opacity;
	opacity: 0.2 !important;
} */
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeaturedPostListing.vue